import * as React from 'react';
const SvgArrowRightToArrowLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M21.5 11h-5.09l1.23-1.229c.2-.2.3-.3.33-.41.03-.1.03-.21 0-.31-.04-.11-.14-.209-.33-.409l-.28-.28c-.13-.13-.22-.22-.3-.28a.3.3 0 0 0-.11-.06.55.55 0 0 0-.31 0c-.11.04-.21.14-.41.33l-1.66 1.66c-.71.709-1.44 1.438-1.52 1.668a.98.98 0 0 0 0 .62c.07.23.81.96 1.52 1.669l1.66 1.659c.2.2.3.3.41.33.1.03.21.03.31 0 .11-.04.21-.14.41-.33l.28-.28.19-.19c.08-.08.12-.15.14-.22.03-.1.03-.21 0-.31-.04-.11-.14-.21-.33-.41l-1.23-1.229h5.09c.28 0 .5-.22.5-.5v-.999c0-.28-.22-.5-.5-.5zM9.44 10.021 7.78 8.362c-.2-.2-.3-.3-.41-.33a.55.55 0 0 0-.31 0c-.11.04-.21.14-.41.33l-.28.28-.19.19c-.08.08-.12.15-.14.22-.03.1-.03.21 0 .31.04.11.14.21.33.41L7.6 11H2.5c-.28 0-.5.22-.5.5v.999c0 .28.22.5.5.5h5.09l-1.23 1.229c-.2.2-.3.3-.33.41-.03.1-.03.21 0 .31.04.11.14.209.33.409l.28.28c.13.13.22.22.3.28.04.03.07.05.11.06.1.03.21.03.31 0 .11-.04.21-.14.41-.33l1.66-1.66c.71-.709 1.44-1.438 1.52-1.668a.98.98 0 0 0 0-.62c-.07-.23-.81-.96-1.52-1.669z"
    />
  </svg>
);
export default SvgArrowRightToArrowLeft;
